import { assert_number_gte_0 } from '@shared/asserts/utils_asserts';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

//id=workspace id
export class DTOWorkspaceBalance extends DTO__database_entity {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.WORKSPACE_BALANCE;

  //STATIC METHODS

  /*
   * DB FIELDS
   */
  credits!: number;

  /*
   * METHODS
   */
  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_number_gte_0(this.credits);
  }
}
